var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('layout-report-with-banner', {
    attrs: {
      "isProgressDone": true,
      "showFooter": true
    },
    scopedSlots: _vm._u([{
      key: "banner",
      fn: function fn() {
        return [_c('v-img', {
          attrs: {
            "src": _vm.headerImage,
            "height": "400"
          }
        }, [_c('v-overlay', {
          attrs: {
            "value": "true",
            "absolute": ""
          }
        }, [_c('v-container', {
          staticClass: "mx-auto"
        }, [_c('v-row', {
          staticClass: "align-left justify-left"
        }, [_c('v-col', {
          staticClass: "ml-4"
        }, [_c('h2', {
          staticClass: "text-md-h2 text-sm-h3 text-h3 font-weight-medium mt-sm-8 mt-md-0",
          domProps: {
            "innerHTML": _vm._s(_vm.headlineText)
          }
        }), _vm.subHeadlineText ? _c('h2', {
          staticClass: "text-md-h4 text-sm-h5 text-h5 font-weight-medium mt-md-3",
          domProps: {
            "innerHTML": _vm._s(_vm.subHeadlineText)
          }
        }) : _vm._e()])], 1)], 1)], 1)], 1)];
      },
      proxy: true
    }, {
      key: "content",
      fn: function fn() {
        return [_vm.isLoading ? _c('v-row', [_c('v-col', {
          attrs: {
            "cols": "12",
            "md": "6"
          }
        }, [_c('v-skeleton-loader', {
          attrs: {
            "type": "list-item-two-line, list-item-two-line, list-item-two-line, list-item-two-line, list-item-two-line"
          }
        })], 1)], 1) : !_vm.bookableServices || _vm.bookableServices.length < 1 ? _c('v-row', [_c('latest-entries-card-empty')], 1) : _c('v-row', [_c('v-card', {
          staticClass: "pt-8",
          attrs: {
            "flat": "",
            "width": "100%"
          }
        }, [_c('v-list', {
          attrs: {
            "two-line": "",
            "outlined": "",
            "flat": ""
          }
        }, [_c('v-list-item-group', {
          model: {
            value: _vm.selectedService,
            callback: function callback($$v) {
              _vm.selectedService = $$v;
            },
            expression: "selectedService"
          }
        }, _vm._l(_vm.bookableServices, function (item, index) {
          return _c('v-list-item', {
            key: index,
            attrs: {
              "outlined": "",
              "to": {
                name: 'BookingAvailability',
                params: {
                  serviceId: item.serviceId
                }
              }
            }
          }, [_c('v-list-item-avatar', [_c('v-icon', {
            staticClass: "grey lighten-1",
            attrs: {
              "dark": ""
            }
          }, [_vm._v(" mdi-cog-outline ")])], 1), _c('v-list-item-content', [_c('v-list-item-title', {
            domProps: {
              "textContent": _vm._s(item.displayName)
            }
          }), _c('v-list-item-subtitle', {
            domProps: {
              "textContent": _vm._s(item.description)
            }
          }), _c('v-list-item-subtitle', {
            domProps: {
              "textContent": _vm._s(item.durationInSeconds / 60 + 'mins')
            }
          })], 1)], 1);
        }), 1)], 1)], 1)], 1), _c('debug', [_vm._v(" " + _vm._s(_vm.bookableServices) + " ")])];
      },
      proxy: true
    }])
  });
}
var staticRenderFns = []

export { render, staticRenderFns }